// One pair, all week (sections/zep-day.liquid): arrows step the row by one photo and switch off at either end; the
// week bar marks the day of the photo in view and jumps to a day's first photo.
const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const phone = window.matchMedia('(max-width: 749px)');

document.querySelectorAll('[data-zep-day]').forEach((day) => {
  const track = day.querySelector('[data-zep-day-track]');
  if (!track) return;
  const prev = day.querySelector('[data-zep-day-prev]');
  const next = day.querySelector('[data-zep-day-next]');
  const chips = [...day.querySelectorAll('[data-zep-day-go]')];
  const moments = [...track.querySelectorAll('.zep-day__moment')];

  // On phones the photo in view is the centred one; on wider screens, the first one showing.
  const inView = () => {
    const mark = phone.matches ? track.scrollLeft + track.clientWidth / 2 : track.scrollLeft + parseFloat(getComputedStyle(track).paddingLeft) + 1;
    let best = 0;
    let gap = Infinity;
    moments.forEach((m, i) => {
      const at = phone.matches ? m.offsetLeft + m.offsetWidth / 2 : m.offsetLeft;
      if (Math.abs(at - mark) < gap) { gap = Math.abs(at - mark); best = i; }
    });
    return moments[best];
  };

  let ticking = false;
  const sync = () => {
    ticking = false;
    if (prev && next) {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    const current = inView()?.dataset.day;
    chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.zepDayGo === current)));
  };
  const queue = () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } };

  const step = (dir) => {
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    if (moments[0]) track.scrollBy({ left: dir * (moments[0].getBoundingClientRect().width + gap), behavior: still ? 'auto' : 'smooth' });
  };
  prev?.addEventListener('click', () => step(-1));
  next?.addEventListener('click', () => step(1));

  chips.forEach((chip) => chip.addEventListener('click', () => {
    const target = moments.find((m) => m.dataset.day === chip.dataset.zepDayGo);
    if (!target) return;
    const left = phone.matches
      ? target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2
      : target.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft);
    track.scrollTo({ left, behavior: still ? 'auto' : 'smooth' });
  }));

  track.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  sync();
});
